import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { CONTACT } from "./data";

function Block({ title, children }) {
  return (
    <div className="border-t border-white/10 py-8 first:border-t-0 first:pt-0">
      <h3 className="mb-4 font-mono-spc text-[11px] uppercase tracking-[0.3em] text-[#4fd1c5]">{title}</h3>
      <div className="space-y-2 font-light leading-relaxed text-[#c0c5ce]/80">{children}</div>
    </div>
  );
}

export default function Datenschutz({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="datenschutz-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[60] flex justify-end bg-[#0d0d0f]/80 backdrop-blur-sm"
        >
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative h-full w-full max-w-2xl overflow-y-auto border-l border-white/10 bg-[#111214] px-8 py-16 lg:px-14"
          >
            <button
              data-testid="datenschutz-close"
              onClick={onClose}
              className="absolute right-6 top-6 flex h-11 w-11 items-center justify-center rounded-sm border border-white/10 text-white transition-colors duration-300 hover:border-[#4fd1c5] hover:text-[#4fd1c5]"
              aria-label="Schliessen"
            >
              <X className="h-5 w-5" strokeWidth={1.5} />
            </button>

            <span className="font-mono-spc text-[11px] uppercase tracking-[0.35em] text-[#4fd1c5]">Rechtliches</span>
            <h2 className="mb-10 mt-4 font-head text-4xl font-light uppercase tracking-tighter text-metal sm:text-5xl">
              Datenschutzerklärung
            </h2>

            <Block title="Verantwortliche Stelle">
              <p>EMMAX Dienstleistungs GmbH</p>
              <p>{CONTACT.address}, {CONTACT.city}, Schweiz</p>
              <p>
                E-Mail:{" "}
                <a href={`mailto:${CONTACT.email}`} className="transition-colors hover:text-[#4fd1c5]">
                  {CONTACT.email}
                </a>
              </p>
            </Block>

            <Block title="Allgemeines">
              <p>
                Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Wir bearbeiten Ihre Daten
                im Einklang mit dem schweizerischen Datenschutzgesetz (DSG) sowie – soweit anwendbar – der
                Datenschutz-Grundverordnung (DSGVO).
              </p>
            </Block>

            <Block title="Bearbeitung im Rahmen des Kontaktformulars">
              <p>
                Wenn Sie uns über das Kontaktformular kontaktieren, verarbeiten wir die von Ihnen angegebenen
                personenbezogenen Daten ausschliesslich zur Bearbeitung Ihrer Anfrage und für eine eventuelle
                spätere Kommunikation. Die Übermittlung Ihrer Daten erfolgt freiwillig.
              </p>
              <p>
                Ihre Daten werden vertraulich behandelt und ohne Ihre ausdrückliche Zustimmung nicht an Dritte
                weitergegeben, sofern hierfür keine gesetzliche Verpflichtung besteht oder die Weitergabe zur
                Bearbeitung Ihrer Anfrage erforderlich ist.
              </p>
            </Block>

            <Block title="Server-Logfiles">
              <p>
                Beim Besuch dieser Website werden automatisch technische Zugriffsdaten (z. B. IP-Adresse, Datum
                und Uhrzeit, aufgerufene Seiten) verarbeitet. Diese Daten dienen der technischen Bereitstellung,
                Sicherheit und Stabilität der Website und werden nicht mit anderen Datenquellen zusammengeführt.
              </p>
            </Block>

            <Block title="Weitergabe an Dritte">
              <p>
                Eine Weitergabe Ihrer Daten erfolgt nur, sofern dies zur Vertragsabwicklung erforderlich ist, Sie
                ausdrücklich eingewilligt haben oder eine gesetzliche Verpflichtung besteht.
              </p>
            </Block>

            <Block title="Aufbewahrung">
              <p>
                Wir bewahren personenbezogene Daten nur so lange auf, wie dies zur Erfüllung des jeweiligen Zwecks
                oder aufgrund gesetzlicher Aufbewahrungspflichten erforderlich ist.
              </p>
            </Block>

            <Block title="Ihre Rechte">
              <p>
                Sie haben im Rahmen der gesetzlichen Bestimmungen das Recht auf Auskunft, Berichtigung, Löschung
                sowie Einschränkung der Bearbeitung Ihrer personenbezogenen Daten. Zur Ausübung Ihrer Rechte
                genügt eine Nachricht an die oben genannte verantwortliche Stelle.
              </p>
            </Block>

            <Block title="Änderungen">
              <p>
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
                rechtlichen Anforderungen entspricht. Es gilt jeweils die auf dieser Website veröffentlichte
                Fassung.
              </p>
            </Block>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
